import { Grid, Tooltip, Button } from '@enterprise-ui/canvas-ui-react';
import { isDate, subDays, endOfMonth, subMonths, startOfMonth, startOfYear } from 'date-fns';
import React from 'react';
import { formatDate } from '../../utility.js';
import { getQuickSelectRange, isRangeDisabled, isRangeInYearRange } from '../utils/gregorianUtility.js';

var checkRange = function checkRange(range) {
  if (!isDate(range.endDate) || !isDate(range.startDate)) {
    console.error('startDate and endDate must be dates');
    return false;
  }
  if (range.endDate < range.startDate) {
    console.error('endDate must come after startDate');
    return false;
  }
  if (!range.label || range.label.length === 0) {
    console.error('label for range must include a label');
    return false;
  }
  return range;
};
var getRange = function getRange(range) {
  return {
    last14Days: {
      endDate: new Date(),
      label: 'Last 14 Days',
      startDate: subDays(new Date(), 14)
    },
    last30Days: {
      endDate: new Date(),
      label: 'Last 30 Days',
      startDate: subDays(new Date(), 30)
    },
    last7Days: {
      endDate: new Date(),
      label: 'Last 7 Days',
      startDate: subDays(new Date(), 7)
    },
    lastMonth: {
      endDate: endOfMonth(subMonths(new Date(), 1)),
      label: 'Last Month',
      startDate: startOfMonth(subMonths(new Date(), 1))
    },
    thisMonth: {
      endDate: endOfMonth(new Date()),
      label: 'This Month',
      startDate: startOfMonth(new Date())
    },
    ytd: {
      endDate: new Date(),
      label: 'Year to Date',
      startDate: startOfYear(new Date())
    }
  }[range];
};
function QuickRangeSelection(_ref) {
  var quickSelectRange = _ref.quickSelectRange,
    setDate = _ref.setDate,
    format = _ref.format,
    setIsCalendarVisible = _ref.setIsCalendarVisible,
    disableDates = _ref.disableDates,
    yearRange = _ref.yearRange;
  return /*#__PURE__*/React.createElement(Grid.Container, {
    spacing: "none",
    className: "C-QuickRangeSelection"
  }, /*#__PURE__*/React.createElement(Grid.Item, {
    className: "hc-pa-min"
  }, /*#__PURE__*/React.createElement(Grid.Container, {
    spacing: "none",
    direction: "column"
  }, getQuickSelectRange(quickSelectRange).map(function (rangeName) {
    var range = typeof rangeName === 'string' ? getRange(rangeName) : checkRange(rangeName);
    return /*#__PURE__*/React.createElement(DateRangeButton, {
      key: range.label,
      isDisabled: isRangeDisabled(range, disableDates) || yearRange && !isRangeInYearRange(range, yearRange),
      range: range,
      setDate: setDate,
      format: format,
      setIsCalendarVisible: setIsCalendarVisible
    }, range.label);
  }))));
}
function DateRangeButton(_ref2) {
  var isDisabled = _ref2.isDisabled,
    range = _ref2.range,
    children = _ref2.children,
    setIsCalendarVisible = _ref2.setIsCalendarVisible,
    setDate = _ref2.setDate,
    format = _ref2.format;
  var setDateRange = function setDateRange(range) {
    setDate({
      endDate: formatDate(range.endDate, format),
      startDate: formatDate(range.startDate, format)
    });
    setIsCalendarVisible(false);
  };
  if (!range) {
    return null;
  }
  return isDisabled ? /*#__PURE__*/React.createElement(Tooltip, {
    content: "Range contains disabled dates",
    location: "right"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "ghost",
    onClick: function onClick() {
      return setDateRange(range);
    },
    disabled: isDisabled,
    className: "hc-pa-md hc-mv-min",
    fullWidth: true
  }, children)) : /*#__PURE__*/React.createElement(Button, {
    type: "ghost",
    onClick: function onClick() {
      return setDateRange(range);
    },
    disabled: isDisabled,
    className: "hc-pa-md hc-mv-min",
    fullWidth: true
  }, children);
}

export { QuickRangeSelection as default };
